import { useSelector } from 'react-redux';

export function useCurrency() {
  const currency = useSelector(state => state.user.user?.displayCurrency, (a,b) => a === b);

  return currency;
}
